/** Copy for a code a "Change code" replaced (status `orphaned`). */
export const shopifyReplacedCopy = {
  noCreatorTag: 'No creator assigned',
  deleteWarning:
    'This code was replaced by a newer one. Deleting it removes it from Shopify for good.',
} as const;
